export const styles = (theme) => ({
  note: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    padding: "32px 56px",
  },
  chip: {
    marginBottom: "10px",
    marginRight: "10px",
  },
  list: {
    maxHeight: "12rem",
  },
  footerList: {
    justifyContent: "flex-end",
    display: "flex",
    bottom: "10%",
    padding: "12px",
  },
  buttonAddPhone: {
    marginLeft: "1rem",
  },
  tabsRoot: {
    backgroundColor: "#fff",
  },
  title: {
    fontWeight: 500,
    marginTop: "3.268%",
    marginBottom: "3.268%",
    fontSize: "24px",
    textAlign: "center",
  },
  titleFrame: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px",
  },
  rightContainer: {
    display: "flex",
  },
  containerPhoneInput: {
    display: "flex",
    flex: 1,
  },
  phoneInput: {
    padding: "12px",
  },
  containerButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginLeft: theme.spacing(2),
  },
});
